import { render, staticRenderFns } from "./CorrelationSummary.vue?vue&type=template&id=74b69180&scoped=true"
import script from "./CorrelationSummary.vue?vue&type=script&lang=js"
export * from "./CorrelationSummary.vue?vue&type=script&lang=js"
import style0 from "./CorrelationSummary.vue?vue&type=style&index=0&id=74b69180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b69180",
  null
  
)

export default component.exports